import React, { useEffect, useMemo, useState } from 'react';
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Grid,
    List,
    ListItem,
    ListItemText,
    Tab,
    Tabs
} from '@mui/material';
import { sortBy } from 'lodash';
import Skills from '@dyl/constants/Skills';
import TaskTypes from '@dyl/task-types';
import withProps from '@dyl/utils/withProps';
import { Link } from 'react-router-dom';
import { useLevels } from "@dyl/systems/LevelsManager";

const ImageList = withProps(List, {
    component: withProps(Grid, { container: true }),
});

const ImageListItem = withProps(ListItem, {
    component: withProps(Grid, {
        item: true,
        xs: 4,
    }),
});

export default function NewRubricModal({ onClose, ...other }) {
    const [skill, setSkill] = useState('');
    const [taskType, setTaskType] = useState('');
    const { globalLevel } = useLevels();

    const visibleTaskTypes = useMemo(() => {
        let res = [...(TaskTypes[globalLevel.label]).filter(x => x.hasRubric)];

        // Filter by skill
        if (skill) {
            res = res.filter(t => t.skill === skill);
        }

        // Sort by display name
        res = sortBy(res, 'label');

        return res;
    }, [skill, globalLevel]);

    // Clear taskType if not currently visible
    useEffect(() => {
        setTaskType(prev => visibleTaskTypes.some(t => t.id === prev) ? prev : '');
    }, [visibleTaskTypes, globalLevel]);

    return (
        <Dialog
            fullWidth
            maxWidth='md'
            onClose={onClose}
            {...other}
        >
            <DialogTitle>
                New rubric
            </DialogTitle>

            <DialogContent>
                <DialogContentText>
                    Please select a task type:
                </DialogContentText>

                <Tabs
                    value={skill}
                    onChange={(e, value) => setSkill(value)}
                    indicatorColor='primary'
                    variant='fullWidth'
                >
                    <Tab value='' label='Show All' />
                    {Skills.map(({ label, value }) => (
                        <Tab key={value} value={value} label={label} />
                    ))}
                </Tabs>

                <ImageList>
                    {visibleTaskTypes.map(({ label, id, v2, skill }) => (
                        <ImageListItem
                            button
                            key={id}
                            selected={taskType === id}
                            onClick={() => setTaskType(id)}
                        >
                            <ListItemText
                                primary={label}
                                secondary={(
                                    Skills.find(s => s.value === skill)?.label
                                )}
                            />
                        </ImageListItem>
                    ))}
                </ImageList>
            </DialogContent>

            <DialogActions>
                <Button color='primary' onClick={onClose}>
                    Cancel
                </Button>
                <Button
                    component={Link}
                    color='primary'
                    disabled={!taskType}
                    to={`/${globalLevel.label}/rubrics/${taskType}/new`}
                >
                    Create
                </Button>
            </DialogActions>
        </Dialog>
    );
}